const buildCreateOrderOfferBody = (user, state) => {
  return {
    customer_id: user.accountable.id,
    address_id: state.selectedAddress,
    date: state.filters.date,
    duration: state.filters.duration,
    time: state.filters.initialHour
  };
};

const buildCheckOpenOfferBody = (user, address) => {
  return {
    customer_id: user.accountable.id,
    city_id: address.district.city.id
  };
};

export default {
  buildCreateOrderOfferBody,
  buildCheckOpenOfferBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/apiOrderOfferHelper.js